module.exports = new __parcel__URL__("oco2-mip-co2budget-yeargrid-v1.thumbnails.fossil.fuel.cement.co2.emissions.uncertainty.f0f57568.png").toString();